var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonPadDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 56,
    height: 56,
    rx: 4,
    fill: "#E7E7E7",
    stroke: "#E0E0E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.7961,
    y: 18.1865,
    width: 25.2654,
    height: 6.11533,
    transform: "rotate(44.4533 15.7961 18.1865)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41.2922,
    y: 18.5601,
    width: 6.75984,
    height: 18.5232,
    transform: "rotate(45.209 41.2922 18.5601)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.58 39.8201L11 23.2401L16.66 17.5801L29 29.9201L41.34 17.5801L47 23.2201L30.42 39.8201C30.2341 40.0075 30.0129 40.1563 29.7692 40.2579C29.5254 40.3594 29.264 40.4117 29 40.4117C28.736 40.4117 28.4746 40.3594 28.2308 40.2579C27.9871 40.1563 27.7659 40.0075 27.58 39.8201Z",
    stroke: "#A8A8A8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPadDown);
export default __webpack_public_path__ + "static/media/button-pad-down.a189b58ef339996dd202a5a30a429c93.svg";
export { ForwardRef as ReactComponent };